var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1759 -442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1759 442)",
    fill: "#59a638",
    stroke: "#59a638",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1778.5,
    cy: 461.5,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1774,
    y1: 456,
    x2: 1784,
    y2: 467,
    stroke: "#59a638",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1774,
    y1: 467,
    x2: 1784,
    y2: 456,
    stroke: "#59a638",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.84044ed68a06e8feb50b421b13fd5a6b.svg";
export { ForwardRef as ReactComponent };